// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"180":"53ba88c8790b7e9f508d","236":"8acd09bbaefa58359786","918":"97d08b899c72b395acf2"}[chunkId] + ".js";
};